/**
 * Admin Bank Account Service
 * Handles all bank account-related admin API calls
 */

import { getApi, postApi, patchApi, deleteApi } from '../adminApi';

/**
 * Get all bank accounts
 * @param {Object} params - Query parameters (page, limit, status, search, verified)
 * @returns {Promise}
 */
export const getBankAccounts = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const endpoint = queryParams ? `bank-accounts?${queryParams}` : 'bank-accounts';
  return getApi(endpoint);
};

/**
 * Update bank account status
 * @param {string} accountId - Bank account ID
 * @param {Object} data - { status: 'active' | 'inactive' }
 * @returns {Promise}
 */
export const updateBankAccountStatus = async (accountId, data) => {
  return patchApi(`bank-accounts/${accountId}/status`, data);
};

/**
 * Verify a bank account
 * @param {string} accountId - Bank account ID
 * @param {Object} data - { verified: boolean }
 * @returns {Promise}
 */
export const verifyBankAccount = async (accountId, data) => {
  return postApi(`bank-accounts/${accountId}/verify`, data);
};

/**
 * Delete a bank account
 * @param {string} accountId - Bank account ID
 * @returns {Promise}
 */
export const deleteBankAccount = async (accountId) => {
  return deleteApi(`bank-accounts/${accountId}`);
};

